import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyANdHz7AX6j8AY6lVwt5_SF7b3VdAQpF5U",
  authDomain: "nrand-docs.firebaseapp.com",
  projectId: "nrand-docs",
  storageBucket: "nrand-docs.appspot.com",
  messagingSenderId: "39474814130",
  appId: "1:39474814130:web:615daba76660d88ee5bdab",
  measurementId: "G-XVSMZLSTE2"
}

class Firebase {
  constructor() {
    firebase.initializeApp(config);
    this.auth = firebase.auth();
    this.db = firebase.firestore();
    this.storage = firebase.storage();

  }  
}
export default Firebase;
